import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { IndexEventsWidgetState } from './IndexEventsWidgetState';
import {
    buildIndexEventsConfigSlice,
    IndexEventsConfigPayloadType,
} from './config/configSlice';

const { reducer: configReducer } = buildIndexEventsConfigSlice();

const widgetStateReducer = combineReducers<IndexEventsWidgetState>({
    config: configReducer,
});

export const indexEventsWidgetsReducer = createWidgetsReducer<
    IndexEventsWidgetState,
    IndexEventsConfigPayloadType
>(WidgetType.INDEX_EVENTS, widgetStateReducer);
